import { HeaderTab } from "../../components/explore/HeaderTab";
import { useHeaderActions } from "../../hooks/useHeaderActions";

type Tab = { href: string; label: string; id: string };

/** Puts the page's tabs in the mobile header while the page is shown. */
export const useHeaderTabs = (tabs: Tab[], active: string): void => {
  useHeaderActions(
    () => (
      <div class="flex items-end h-full">
        {tabs.map((tab) => (
          <HeaderTab key={tab.id} href={tab.href} isActive={tab.id === active}>
            {tab.label}
          </HeaderTab>
        ))}
      </div>
    ),
    [active, tabs[0]?.href],
  );
};

export const EXPLORE_TABS: Tab[] = [
  { id: "articles", href: "/articles", label: "Articles" },
  { id: "authors", href: "/authors", label: "Authors" },
];

export const authorTabs = (alias: string): Tab[] => [
  { id: "profile", href: `/authors/${alias}`, label: "Profile" },
  { id: "articles", href: `/authors/${alias}/articles`, label: "Articles" },
];
